module.exports = __webpack_public_path__ + "03_glasses_blue.e88945fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer4/03_glasses_blue.png
// module id = Mtwl
// module chunks = 0